import angular from 'angular';
import '../../shared.module';
import template from './button.component.html';
import './button.component.scss';

class ButtonController {
  $onInit() {
    this.variant = this.variant || 'primary';
    this.size = this.size || 'md';
    this.type = this.type || 'button';
  }

  handleClick($event) {
    if (this.disabled || this.loading) return;
    if (this.onClick) this.onClick({ $event });
  }
}

angular.module('app.shared').component('cpButton', {
  bindings: {
    variant: '@',
    size: '@',
    type: '@',
    icon: '@',
    iconPosition: '@',
    ariaLabel: '@',
    disabled: '<',
    loading: '<',
    block: '<',
    onClick: '&'
  },
  controller: ButtonController,
  controllerAs: 'vm',
  transclude: true,
  template
});
